import { Box, FormControl, IconButton, InputLabel, MenuItem, Select } from '@mui/material';
import { FilterAlt } from '@mui/icons-material';
import { CampaignContext } from '../../contexts/CampaignContext';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { CONTENT_TYPES } from '../../constants/array';
import { IMyEntities } from '../../interfaces/tasks';

interface IHeaderPendingAds {
	fetchedAccounts: IMyEntities[];
	selectedAccountId: number | null;
	setSelectedAccountId: (val: number | null) => void;
}

export default function HeaderPendingAds({ fetchedAccounts, selectedAccountId, setSelectedAccountId }: IHeaderPendingAds) {
	const { fetchedCategories, selectedContentType, selectedPlatformId, selectedCategoryId, fetchedMedias, setSelectedCategoryId, setSelectedPlatformId, setSelectedContentType } = useContext(CampaignContext);

	const { t } = useTranslation();

	const handleSelectCategory = (e: any) => {
		setSelectedCategoryId(e.target.value);
	};

	const handleSelectPlatform = (e: any) => {
		setSelectedPlatformId(e.target.value);
	};

	const handleSelectContentType = (e: any) => {
		setSelectedContentType(e.target.value);
	};

	const handleSelectAccount = (e: any) => {
		setSelectedAccountId(e.target.value);
	};

	return (
		<Box className="mt-6 flex w-full rounded-lg bg-white px-6 py-4">
			<IconButton className="hidden lg:block">
				<FilterAlt />
			</IconButton>
			<Box className="flex flex-1 flex-wrap justify-evenly gap-y-4 lg:flex-nowrap">
				<FormControl className="items-center" size="small">
					<InputLabel>{t('category')}</InputLabel>
					<Select
						value={selectedCategoryId}
						variant={'outlined'}
						label={t('category')}
						onChange={handleSelectCategory}
						className="min-w-[240px] flex-shrink-0 basis-1/4"
						MenuProps={{
							PaperProps: {
								style: {
									maxHeight: 200,
									overflowY: 'auto',
								},
							},
						}}
					>
						<MenuItem value={undefined}>{t('all')}</MenuItem>
						{fetchedCategories?.map((cat, i) => (
							<MenuItem key={i} value={cat.id}>
								{cat.title}
							</MenuItem>
						))}
					</Select>
				</FormControl>
				<FormControl className="items-center" size="small">
					<InputLabel>{t('platform')}</InputLabel>
					<Select
						value={selectedPlatformId}
						variant={'outlined'}
						label={t('platform')}
						onChange={handleSelectPlatform}
						className="min-w-[240px] flex-shrink-0 basis-1/4"
						MenuProps={{
							PaperProps: {
								style: {
									maxHeight: 200,
									overflowY: 'auto',
								},
							},
						}}
					>
						<MenuItem value={undefined}>{t('all')}</MenuItem>
						{fetchedMedias?.map((media, i) => (
							<MenuItem key={i} value={media.id}>
								{media.title}
							</MenuItem>
						))}
					</Select>
				</FormControl>
				<FormControl className="items-center" size="small">
					<InputLabel>{t('content_type')}</InputLabel>
					<Select
						value={selectedContentType}
						variant={'outlined'}
						label={t('content_type')}
						onChange={handleSelectContentType}
						className="min-w-[240px] flex-shrink-0 basis-1/4"
						MenuProps={{
							PaperProps: {
								style: {
									maxHeight: 200,
									overflowY: 'auto',
								},
							},
						}}
					>
						<MenuItem value={undefined}>{t('all')}</MenuItem>
						{CONTENT_TYPES?.map((type, i) => (
							<MenuItem key={i} value={type}>
								{t(type)}
							</MenuItem>
						))}
					</Select>
				</FormControl>
				<FormControl className="items-center" size="small">
					<InputLabel>{t('account')}</InputLabel>
					<Select
						value={selectedAccountId}
						variant={'outlined'}
						label={t('account')}
						onChange={handleSelectAccount}
						className="min-w-[240px] flex-shrink-0 basis-1/4"
						MenuProps={{
							PaperProps: {
								style: {
									maxHeight: 200,
									overflowY: 'auto',
								},
							},
						}}
					>
						<MenuItem value={undefined}>{t('all')}</MenuItem>
						{fetchedAccounts?.map((acc, i) => (
							<MenuItem key={i} value={acc.id}>
								{acc.title}
							</MenuItem>
						))}
					</Select>
				</FormControl>
			</Box>
		</Box>
	);
}
